<template>
    <comp-9-art-adherence :section="9" :page="45" :nextDisabled="nextDisabled" :next="nextScreen">
        <p class="caption font-weight-bold mb-1 input-label">
            Have you ever been prescribed ART (antiretroviral therapy or HIV medicine)?
        </p>
        <v-radio-group v-model="artSelection" column>
            <v-radio v-for="choice in artChoices" :key="choice.id" :label="choice.text" :value="choice"></v-radio>
        </v-radio-group>
        <v-text-field v-if="artSelection && artSelection.userEntered" outline single-line type="text" v-model.trim="artSelectionResponse"></v-text-field>
    </comp-9-art-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            artSelection: null,
            artSelectionResponse: null
        };
    },
    computed: {
        artResponse() {
            let selectedArtResponse = find(this.artChoices, 'selected');

            if (selectedArtResponse) {
                return selectedArtResponse;
            } else return null;
        },
        artChoices: sync('section9/artChoices'),
        nextScreen() {
            if (this.artSelection) {
                return `/page/9/${this.artSelection.nextScreen}`;
            }

            return null;
        }
    },
    methods: {
        nextDisabled() {
            if (this.artSelection && this.artSelection.userEntered && !this.artSelectionResponse) {
                return true;
            } else {
                return !this.artSelection;
            }
        }
    },
    watch: {
        artSelection(newArtSelection) {
            forEach(this.artChoices, o => {
                if (o.id === newArtSelection.id) {
                    o.selected = true;
                    if (o.userEntered) {
                        o.response = this.artSelectionResponse;
                    }
                } else {
                    o.selected = false;
                    if (o.userEntered) {
                        o.response = null;
                    }
                }
            });
        },
        artSelectionResponse(newArtSelectionResponse) {
            forEach(this.artChoices, o => {
                if (o.id === this.artSelection.id && o.userEntered) {
                    o.response = newArtSelectionResponse;
                } else if (o.userEntered) {
                    o.response = null;
                }
            });
        }
    },
    mounted() {
        this.artSelection = this.artResponse;
        if (this.artSelection && this.artSelection.userEntered && this.artSelection.response) {
            this.artSelectionResponse = this.artSelection.response;
        }
    }
};
</script>
